import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';

@Component({
  selector: 'app-dialog',
  imports: [],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DialogComponent {
  @Input() open = false;
  @Input() title = 'Header';
  @Input() dialogHeight = '60%';
  @Input() dialogWidth = '40%';
  @Input() backdropcloseactiondisabled = true;
  @Input() secondaryButtonLabel?: string;
  @Input() primaryButtonLabel?: string;
  @Input() onSecondaryButtonClick = (event: Event) => {};
  @Input() onPrimaryButtonClick = (event: Event) => {};
  @Input() withFooter = true;
  @Input() primaryButtonDisabled = false;
  @Input() closeOnPrimaryAction = true;
  @Input() closeOnSecondaryAction = true;
}
